export default {
  'menu.crm.nav.performance': '業績',
  'menu.crm.performance.overview': '業績概覽',
  'menu.crm.performance.targets': '目標管理',
  'menu.crm.performance.entries': '業績明細',
  'menu.crm.performance.splits': '業績分攤',
  'menu.crm.performance.team': '團隊達成',
  'menu.crm.performance.reconciliation': '核對與鎖定',

  'menu.crm.scope.my': '我負責的',
  'menu.crm.scope.team': '下屬負責的',
  'menu.crm.scope.collab': '我協作的',
  'menu.crm.scope.followed': '我關注的',
  'menu.crm.scope.all': '全部',
  'menu.crm.page.overview': '概覽',
  'menu.crm.page.approval': '審批',
  'menu.crm.page.calendar': '日曆',
  'menu.crm.page.business-trip': '出差助理',
  'menu.crm.page.task': '任務',
  'menu.crm.page.follow-up': '跟進',
  'menu.crm.page.attachment': '附件',
  'menu.crm.page.lead-source': '來源分析',

  'menu.crm.help': '幫助',
  'menu.crm.nav.workbench': '工作台',
  'menu.crm.nav.marketing': '行銷',
  'menu.crm.nav.lead': '線索',
  'menu.crm.nav.customer': '客戶',
  'menu.crm.nav.contact': '聯絡人',
  'menu.crm.nav.opportunity': '商機',
  'menu.crm.nav.quote': '報價',
  'menu.crm.nav.product': '產品',
  'menu.crm.nav.contract': '合約',
  'menu.crm.nav.receipt': '收款',
  'menu.crm.nav.analysis': '分析',
  'menu.zy-crm.products.catalog': '產品目錄',
  'menu.zy-crm.workbench.overview': '概覽',

  'menu.workbench': '工作台',
  'menu.more-blocks': '更多區塊',
  'menu.home': '首頁',
  'menu.admin': '管理頁',
  'menu.admin.sub-page': '二級管理頁',
  'menu.login': '登入',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析頁',
  'menu.dashboard.monitor': '監控頁',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表單頁',
  'menu.form.basic-form': '基礎表單',
  'menu.form.step-form': '分步表單',
  'menu.form.step-form.info': '分步表單（填寫轉帳資訊）',
  'menu.form.step-form.confirm': '分步表單（確認轉帳資訊）',
  'menu.form.step-form.result': '分步表單（完成）',
  'menu.form.advanced-form': '高級表單',
  'menu.list': '列表頁',
  'menu.list.table-list': '查詢表格',
  'menu.list.basic-list': '標準列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜尋列表',
  'menu.list.search-list.articles': '搜尋列表（文章）',
  'menu.list.search-list.projects': '搜尋列表（項目）',
  'menu.list.search-list.applications': '搜尋列表（應用）',
  'menu.profile': '詳情頁',
  'menu.profile.basic': '基礎詳情頁',
  'menu.profile.advanced': '高級詳情頁',
  'menu.result': '結果頁',
  'menu.result.success': '成功頁',
  'menu.result.fail': '失敗頁',
  'menu.exception': '異常頁',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '觸發錯誤',
  'menu.account': '個人頁',
  'menu.account.center': '個人中心',
  'menu.account.workbench': '回到工作台',
  'menu.account.tenantManagement': '企業管理',
  'menu.account.trigger': '觸發報錯',
  'menu.account.logout': '退出登入',
  'menu.editor': '圖形編輯器',
  'menu.editor.flow': '流程編輯器',
  'menu.editor.mind': '腦圖編輯器',
  'menu.editor.koni': '拓撲編輯器',
  'menu.zy-crm': '組織管理後台',
  'menu.zy-crm.workbench': '工作台',
  'menu.zy-crm.workbench.dashboard': '儀表盤',
  'menu.zy-crm.approvals': '審批中心',
  'menu.zy-crm.leadManagement': '線索',
  'menu.zy-crm.leadManagement.lead.my': '我負責的',
  'menu.zy-crm.leadManagement.lead.team': '下屬負責的',
  'menu.zy-crm.leadManagement.lead.collab': '我協作的',
  'menu.zy-crm.leadManagement.lead.pool': '線索池',
  'menu.zy-crm.leadManagement.lead.all': '全部',
  'menu.zy-crm.customerManagement': '客戶',
  'menu.zy-crm.customerManagement.customer.my': '我負責的',
  'menu.zy-crm.customerManagement.customer.team': '下屬負責的',
  'menu.zy-crm.customerManagement.customer.collab': '我協作的',
  'menu.zy-crm.customerManagement.customer.pool': '客戶池',
  'menu.zy-crm.customerManagement.customer.all': '全部',
  'menu.zy-crm.customerManagement.contact': '聯絡人',
  'menu.zy-crm.customerManagement.contact.my': '我負責的',
  'menu.zy-crm.customerManagement.contact.team': '下屬負責的',
  'menu.zy-crm.customerManagement.contact.collab': '我協作的',
  'menu.zy-crm.customerManagement.contact.all': '全部',
  'menu.zy-crm.customerManagement.contact.detail': '聯絡人詳情',
  'menu.zy-crm.salesManagement': '商機',
  'menu.zy-crm.salesManagement.opportunity.my': '我負責的',
  'menu.zy-crm.salesManagement.opportunity.followed': '我關注的商機',
  'menu.zy-crm.salesManagement.opportunity.team': '下屬負責的',
  'menu.zy-crm.salesManagement.opportunity.collab': '我協作的',
  'menu.zy-crm.salesManagement.opportunity.all': '全部',
  'menu.zy-crm.salesManagement.opportunity.pool': '商機池',
  'menu.zy-crm.salesManagement.quote': '報價單',
  'menu.zy-crm.salesManagement.quote.my': '我負責的',
  'menu.zy-crm.salesManagement.quote.team': '下屬負責的',
  'menu.zy-crm.salesManagement.quote.collab': '我協作的',
  'menu.zy-crm.salesManagement.quote.all': '全部',
  'menu.zy-crm.salesManagement.quote.detail': '報價單詳情',
  'menu.zy-crm.salesManagement.product': '產品',
  'menu.zy-crm.salesManagement.product.detail': '產品詳情',
  'menu.zy-crm.contractAndReceipt': '合同與回款',
  'menu.zy-crm.contractAndReceipt.contract': '合同',
  'menu.zy-crm.contractAndReceipt.contract.detail': '合同詳情',
  'menu.zy-crm.contractAndReceipt.receipt': '回款',
  'menu.zy-crm.contractAndReceipt.receipt.detail': '回款詳情',
  'menu.zy-crm.contractAndReceipt.receipt-schedule': '回款計劃',
  'menu.zy-crm.contractAndReceipt.receipt-schedule.detail': '回款計劃詳情',
  'menu.zy-crm.contractAndReceipt.invoice': '發票',
  'menu.zy-crm.contractAndReceipt.invoice.detail': '發票詳情',
  'menu.zy-crm.contractAndReceipt.invoiceProfile': '發票資訊',
  'menu.zy-crm.collaboration': '協同辦公',
  'menu.zy-crm.collaboration.calendar': '日曆',
  'menu.zy-crm.collaboration.followUps': '跟進記錄',
  'menu.zy-crm.collaboration.tasks': '任務中心',
  'menu.zy-crm.collaboration.attachments': '附件中心',
  'menu.zy-crm.analytics': '數據分析',
  'menu.zy-crm.analytics.leadSourceAnalysis': '線索來源分析',
  'menu.zy-crm.analytics.businessMap': '業務地圖',
  'menu.zy-crm.analytics.governance': '數據治理',
  'menu.zy-crm.settings.marketing': '市場活動設置',
  'menu.zy-crm.systemConfig': '系統設定',
  'menu.zy-crm.systemConfig.general': '系統通用',
  'menu.zy-crm.systemConfig.lead': '線索設置',
  'menu.zy-crm.systemConfig.customer': '客戶設置',
  'menu.zy-crm.systemConfig.opportunity': '商機設置',
  'menu.zy-crm.systemConfig.product': '產品設置',
  'menu.zy-crm.systemConfig.marketing': '市場活動設置',
  'menu.zy-crm.systemConfig.contract': '合同設置',
  'menu.zy-crm.systemConfig.permissions': '權限配置',
  'menu.zy-crm.systemConfig.taxonomies': '標籤管理',
  'menu.zy-crm.systemConfig.automationRules': '自動化規則',
  'menu.zy-crm.systemConfig.invoiceProfile': '發票信息',
  'menu.zy-crm.systemConfig.tavily': 'Tavily 設定',
  'menu.zy-crm.systemConfig.modelSettings': '模型設定',
  'menu.zy-crm.systemConfig.customerPoolConfigs': '客戶公海配置',
  'menu.zy-crm.systemConfig.leadPoolConfigs': '線索池配置',
  'menu.zy-crm.systemConfig.leadAssignRules': '線索分配規則',
  'menu.zy-crm.systemConfig.customerLimitConfigs': '私池上限配置',
  'menu.zy-crm.systemConfig.dictionaryManagement': '字典管理',
  'menu.zy-crm.systemConfig.productCategories': '產品分類配置',
  'menu.zy-crm.systemConfig.opportunityPipelines': '商機管道',
  'menu.zy-crm.systemConfig.opportunityStages': '商機階段',
  'menu.zy-crm.systemConfig.areas': '地區配置',
  'menu.zy-crm.systemConfig.sourceChannels': '來源渠道配置',
  'menu.zy-crm.systemConfig.marketingCampaignTypes': '活動類型',
  'menu.zy-crm.systemConfig.marketingTouchpointTypes': '接入點類型',
  'menu.zy-crm.systemConfig.industries': '行業配置',
  'menu.zy-crm.systemConfig.contractConfigs': '合同配置',
  'menu.zy-crm.systemConfig.contractCodeRules': '合同編號規則',
  'menu.zy-crm.systemConfig.productCodeRules': '產品編號規則',
  'menu.zy-crm.dashboard': '儀表盤',
  'menu.zy-crm.calendar': '日曆',
  'menu.zy-crm.lead': '線索',
  'menu.zy-crm.lead.my': '我的線索',
  'menu.zy-crm.lead.pool': '線索池',
  'menu.zy-crm.lead.all': '全部線索',
  'menu.zy-crm.customer': '客戶',
  'menu.zy-crm.customer.my': '我的客戶',
  'menu.zy-crm.customer.pool': '客戶池',
  'menu.zy-crm.customer.all': '全部客戶',
  'menu.zy-crm.contact': '聯絡人',
  'menu.zy-crm.contact.detail': '聯絡人詳情',
  'menu.zy-crm.opportunity': '商機',
  'menu.zy-crm.opportunity.my': '我的商機',
  'menu.zy-crm.opportunity.all': '全部商機',
  'menu.zy-crm.opportunity.pool': '商機池',
  'menu.zy-crm.opportunity.detail': '商機詳情',
  'menu.zy-crm.quote': '報價單',
  'menu.zy-crm.quote.detail': '報價單詳情',
  'menu.zy-crm.product': '產品',
  'menu.zy-crm.product.detail': '產品詳情',
  'menu.zy-crm.contract': '合同',
  'menu.zy-crm.contract.detail': '合同詳情',
  'menu.zy-crm.receipt': '回款',
  'menu.zy-crm.receipt.detail': '回款詳情',
  'menu.zy-crm.receipt-schedule': '回款計劃',
  'menu.zy-crm.receipt-schedule.detail': '回款計劃詳情',
  'menu.zy-crm.invoice': '發票',
  'menu.zy-crm.invoice.detail': '發票詳情',
  'menu.zy-crm.invoiceProfile': '發票資訊',
  'menu.zy-crm.followUps': '跟進記錄',
  'menu.zy-crm.tasks': '任務中心',
  'menu.zy-crm.attachments': '附件中心',
  'menu.zy-crm.governance': '數據治理',
  'menu.zy-crm.automationRules': '自動化規則',
  'menu.zy-crm.analytics.leadSource': '線索來源分析',
  'menu.zy-crm.permissions': '數據權限',
  'menu.zy-crm.customerLimitConfigs': '私池上限配置',
  'menu.zy-crm.customerPoolConfigs': '客戶公海配置',
  'menu.zy-crm.leadPoolConfigs': '線索池配置',
  'menu.zy-crm.leadAssignRules': '線索分配規則',
  'menu.zy-crm.sourceChannels': '來源渠道配置',
  'menu.zy-crm.opportunityPipelines': '商機管道',
  'menu.zy-crm.opportunityStages': '商機階段',
  'menu.zy-crm.areas': '地區配置',
  'menu.zy-crm.industries': '行業配置',
  'menu.zy-crm.contractConfigs': '合同配置',
  'menu.zy-crm.productCategories': '產品分類配置',
  'menu.zy-crm.contractCodeRules': '合同編號規則',
  'menu.zy-crm.productCodeRules': '產品編號規則',
  'menu.zy-crm.leads': '線索',
  'menu.zy-crm.leads.overview': '概覽',
  'menu.zy-crm.leads.my': '我負責的',
  'menu.zy-crm.leads.team': '下屬負責的',
  'menu.zy-crm.leads.pool': '線索池',
  'menu.zy-crm.leads.all': '全部',
  'menu.zy-crm.customers': '客戶',
  'menu.zy-crm.customers.overview': '概覽',
  'menu.zy-crm.customers.my': '我負責的',
  'menu.zy-crm.customers.team': '下屬負責的',
  'menu.zy-crm.customers.collab': '我協作的',
  'menu.zy-crm.customers.pool': '客戶池',
  'menu.zy-crm.customers.all': '全部',
  'menu.zy-crm.contacts': '聯絡人',
  'menu.zy-crm.contacts.overview': '概覽',
  'menu.zy-crm.contacts.my': '我負責的',
  'menu.zy-crm.contacts.team': '下屬負責的',
  'menu.zy-crm.contacts.collab': '我協作的',
  'menu.zy-crm.contacts.all': '全部',
  'menu.zy-crm.opportunities': '商機',
  'menu.zy-crm.opportunities.overview': '概覽',
  'menu.zy-crm.opportunities.my': '我負責的',
  'menu.zy-crm.opportunities.followed': '我關注的商機',
  'menu.zy-crm.opportunities.team': '下屬負責的',
  'menu.zy-crm.opportunities.collab': '我協作的',
  'menu.zy-crm.opportunities.pool': '商機池',
  'menu.zy-crm.opportunities.all': '全部',
  'menu.zy-crm.quotes': '報價單',
  'menu.zy-crm.quotes.my': '我負責的',
  'menu.zy-crm.quotes.team': '下屬負責的',
  'menu.zy-crm.quotes.collab': '我協作的',
  'menu.zy-crm.quotes.all': '全部',
  'menu.zy-crm.contracts': '合同',
  'menu.zy-crm.contracts.my': '我負責的',
  'menu.zy-crm.contracts.team': '下屬負責的',
  'menu.zy-crm.contracts.collab': '我協作的',
  'menu.zy-crm.contracts.all': '全部',
  'menu.zy-crm.receipts': '回款',
  'menu.zy-crm.receipts.list': '回款',
  'menu.zy-crm.receipts.schedules': '回款計劃',
  'menu.zy-crm.receipts.schedules.detail': '回款計劃詳情',
  'menu.zy-crm.invoices': '發票',
  'menu.zy-crm.invoices.detail': '發票詳情',
  'menu.zy-crm.products': '產品',
  'menu.zy-crm.products.detail': '產品詳情',
  'menu.zy-crm.marketing': '市場活動',
  'menu.zy-crm.marketing.campaigns': '活動列表',
  'menu.zy-crm.marketing.campaigns.detail': '活動詳情',
};
